import React, { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Prismic, { getDocumentByUid, getDocumentsByType } from 'helpers/Prismic';
import { globalPropsRequests } from 'utils/globalProps';
import Image from 'next/image';
import breakPoints from 'helpers/Styles';
import Head from 'next/head';
import Script from 'next/script';

function LimitedEditionPage({ content }) {
  // console.log('TEST content', content);
  const { isFallback } = useRouter();

  if (isFallback) {
    return <Loader />;
  }

  if (!content) {
    return <Error code={404} />;
  }

  const {
    og_description: ogDescription,
    og_image: ogImage,
    seo_title: seoTitle,
    seo_description: seoDescription,
    banner_title,
    banner_description,
    body,
  } = content;

  const primary = body[0]?.primary;
  const items = body[0]?.items;

  return content ? (
    <>
      <Head>
        <title>{seoTitle}</title>
        <meta name="description" content={seoDescription} />
        <meta property="og:description" content={ogDescription} />
        <meta
          property="og:image"
          content={
            ogImage?.url
              ? ogImage?.url
              : 'https://cdn.shopify.com/s/files/1/0522/3320/7988/files/ogImage.png?v=1713964496'
          }
        />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="1024" />
      </Head>
      <Script
        dangerouslySetInnerHTML={{
          __html: `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','${process.env.NEXT_PUBLIC_GTM_ID}');`,
        }}
        strategy="lazyOnload"
      />
      <div className="main-container-limited-edition">
        <div className="header-section">
          <p className="title">{banner_title}</p>
          <p className="description">{banner_description}</p>
        </div>

        <div className="card-section">
          {body.map((item, i) => {
            return (
              <>
                <div
                  className="card-box"
                  style={{
                    backgroundImage: `url(${item?.primary?.card_image?.url})`,
                  }}
                >
                  <div
                    className="card-image"
                    onClick={() =>
                      (window.location.href = item?.primary?.redirect_link)
                    }
                  >
                    {/* <div>
                    <Image draggable={false}  src={item?.primary?.product_image?.url} width={300} height={185} style={{position: 'absolute', bottom: '20px'}}/>
                  </div> */}
                  </div>

                  <div className="card-features">
                    {item?.items.map((item, i) => {
                      return (
                        <div className="unique-section">
                          <Image
                            draggable={false}
                            src={item?.icon?.url}
                            width={15}
                            height={15}
                          />
                          <p className="unique-info">{item?.unique_info}</p>
                        </div>
                      );
                    })}
                  </div>

                  <div
                    className="card-learn-more"
                    onClick={() =>
                      (window.location.href = item?.primary?.redirect_link)
                    }
                  >
                    <p>LEARN MORE</p>
                  </div>
                </div>
              </>
            );
          })}

          <div></div>
        </div>
      </div>

      <style jsx global>
        {`
          .main-container-limited-edition {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            padding-bottom: 50px;
          }
          .header-section {
            display: flex;
            justify-content: center;
            align-items: center;
            flex-direction: column;
            margin-top: 40px;
          }
          .title {
            font-size: 48px;
            text-transform: uppercase;
            font-family: 'Roboto-Medium';
            margin: 0;
          }
          .description {
            margin: 20px 0 40px 0;
            width: 53%;
            text-align: center;
            font-size: 16px;
            font-family: 'Roboto-Medium';
          }
          .card-section {
            display: flex;
            flex-wrap: wrap;
            width: 80%;
            justify-content: center;
            align-items: center;
          }
          .card-box {
            width: 350px;
            height: 600px;
            position: relative;
            background-size: contain;
            background-repeat: no-repeat;
            border-radius: 10px;
            float: left;
            margin-left: 20px;
            margin-bottom: 20px;
          }
          .card-image {
            height: 312px;
            display: flex;
            justify-content: center;
            align-items: end;
            cursor: pointer;
          }
          .card-features {
            padding: 25px 20px;
            height: 234px;
            display: flex;
            justify-content: start;
            align-items: start;
            flex-direction: column;
          }
          .card-learn-more {
            height: 55px;
            background-color: #B70004;
            display: flex;
            justify-content: center;
            align-items: center;
            position: absolute;
            bottom: 2px;
            width: 100%;
            border-bottom-right-radius: 10px;
            border-bottom-left-radius: 10px;
            cursor: pointer;
            font-family: "Roboto-Medium";
          }
          .unique-info {
            font-size: 14px;
            font-family: "Roboto-Medium";
            margin: 0;
            margin-left: 5px;
          }
          .unique-section {
            width: 100%;
            display: flex;
            justify-content: start;
            align-items: center;
            margin-bottom: 5px;
          }
          @media (max-width: ${breakPoints.small}) {
            .card-section {
              width: 100%;
              padding: 15px;
            }
            .card-box {
              height: 540px;
            }
            .card-image {
              height: 56%;
            }
            .unique-info {
              font-size: 12px;
            }
            .card-box {
              margin-left: 0;
              margin-right: 0;
            }
            .title {
              font-size: 24px;
            }
            .description {
              margin: 10px 0 20px 0;
              width: 90%;
              font-size: 12px;
            }
            .card-learn-more  {
              bottom: 0;
            }
            .main-container {
              padding-bottom: 10px;
            }
          }
        }
      `}
      </style>
    </>
  ) : (
    <div>Data not found</div>
  );
}

export async function getStaticProps({ preview = false, previewData }) {
  const { ref } = previewData || {};
  const global = {};
  await Promise.all(globalPropsRequests)
    .then((responses) => {
      responses.forEach((res) => {
        if (res) {
          const [id, body] = res;
          global[id] = body.data;
        }
      });
    })
    .catch(() => null);
  const content = await Prismic.getByUID(
    'limited_edition_page',
    'limited-edition',
    ref ? { ref } : null,
  );

  if (!content) {
    return { notFound: true };
  }

  const results = {};

  return {
    props: {
      global,
      content: content?.data || null,
      preview,
    },
    revalidate: 3600,
  };
}

export default LimitedEditionPage;
